import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetExcelComparison, GetExcelKlauselComparison };

function GetExcelComparison(contractsToCompare, orientation, language, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + "/comparison/excel/contract?orientation=" + 
        (orientation ? orientation : false) + 
        (language ? "&language=" + language : ""),
      contractsToCompare,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetExcelKlauselComparison(klauselRequest, showGavDetails, orientation, language, onSuccess, onError) {
    var headers = getAuthHeader();
  
    axios
      .put(
        process.env.VUE_APP_BASE_API_URL + "/comparison/excel/klausel" + 
          (orientation ? "?orientation=true" : "?orientation=false") + 
          (showGavDetails ? "&gavdetails=true" : "") +
          (language ? "&language=" + language : ""),
        klauselRequest,
        headers
      )
      .then((response) => {
        onSuccess(response.data);
      })
      .catch((error) => {
        onError(error);
      });
  }